/**
 * Export the beyond runtime environment service
 */
export { BydRuntimeService } from './byd-runtime.service';
